import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { filter, tap } from 'rxjs';

import { StoreService } from '@store/store.service';
import { LoadingScreenComponent } from './loading-screen.component';

@Injectable({ providedIn: 'root' })
export class LoadingScreenService {
  private overlayRef: OverlayRef | null = null;

  constructor(
    private router: Router,
    private store: StoreService,
    private overlay: Overlay,
  ) {
    this.store.loadingState$
      .pipe(
        tap(state => this.toggleOverlay(state.isLoading)),
        takeUntilDestroyed(),
      )
      .subscribe();

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => this.store.setIsLoading(false)),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  private toggleOverlay(isLoading: boolean): void {
    if (isLoading) {
      this.showOverlay();
    } else {
      this.disposeOverlay();
    }
  }

  private showOverlay(): void {
    if (this.overlayRef) return;

    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      panelClass: 'loading-screen-overlay',
      positionStrategy: this.overlay.position().global(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });

    const portal = new ComponentPortal(LoadingScreenComponent);
    this.overlayRef.attach(portal);
  }

  private disposeOverlay(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
